<template>

<app-section>

    <app-filter>

        <app-input icon="search" :is-inline="true" :is-multiple="true" type="suggest" placeholder="Search patients" v-model="filter.patient" class="filter-search" />

    </app-filter>

    <app-panel :title="title" :is-loading="is.loading && !is.initialised" :is-empty="is.empty" empty-message="No records found." :button="(patient) ? 'Close Patient' : false" v-on:button="onCloseClick">

        <app-table>
            <thead>
                <tr>
                    <th width="240">Domain</th>
                    <th>Progression</th>
                    <th v-if="!patient" align="center" width="100">Completed</th>
                    <th v-if="patient" align="center" width="100">Before</th>
                    <th align="center" width="100">After</th>
                    <th v-if="patient" width="160" align="center"></th>
                    <th v-if="patient" width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.domain }}</td>
                    <td v-if="!patient"><app-progress :total="item.started" :value="item.completed" /></td>
                    <td v-if="patient"><app-progress :progress="item.progress" /></td>
                    <td v-if="!patient" align="center">{{ item.completed }} / {{ item.started }}</td>
                    <td v-if="patient && item.before" align="center">{{ item.before }}</td>
                    <td v-if="patient && !item.before" align="center">-</td>
                    <td v-if="item.after" align="center">{{ item.after }}</td>
                    <td v-if="!item.after" align="center">-</td>
                    <td v-if="patient">
                        <app-button theme="grey" text="Set as Reviewed" :subtext="(item.datereviewed) ? item.datereviewed : false" v-on:click.native="onReviewClick(item)" v-if="!item.reviewed && item.started" />
                        <app-button theme="green" :text="(item.namereviewed) ? item.namereviewed : 'Reviewed'" :subtext="(item.datereviewed) ? item.datereviewed : false" v-on:click.native="onReviewClick(item)" v-if="item.reviewed && item.started" />
                    </td>
                    <td v-if="patient"><app-button v-if="item.started" text="View" route="Domain" :params="{domain: item.id, patient: patient.id}" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <div class="review" v-if="is.reviewing && !is.reviewing.reviewed">

        <div class="review-content">

            <input type="text" v-model="model.name" ref="input" placeholder="Enter name of reviewer..." />

            <app-button theme="green" :is-disabled="!model.name" icon="&check;" v-on:click.native="onConfirmReview" />
            <app-button theme="red" icon="x" v-on:click.native="onCancelReview" />

        </div>

    </div>

    <div class="review" v-if="is.reviewing && is.reviewing.reviewed">

        <div class="review-content">

            <p>Are you sure you wish to remove the Reviewed status for this domain?</p>

            <app-button theme="green" icon="&check;" v-on:click.native="onConfirmReview" />
            <app-button theme="red" icon="x" v-on:click.native="onCancelReview" />

        </div>

    </div>

    <app-actions class="actions">

        <div class="actions-counts">

            <div class="actions-counts-item" :data-band="genericBand" v-if="record">
                <div class="actions-counts-item-value">{{ record.score.generic }}</div>
                <div class="actions-counts-item-text">20 Generic Questions Score</div>
            </div>

            <div class="actions-counts-item" :data-band="selfBand" v-if="record">
                <div class="actions-counts-item-value">{{ record.score.self }}</div>
                <div class="actions-counts-item-text">16 Self-perception questions score</div>
            </div>

        </div>

        <div class="actions-buttons">

            <app-button text="Save as PDF" theme="grey" v-on:click.native="onExportClick('pdf')" />
            <app-button text="Download as .xls" theme="grey" v-on:click.native="onExportClick('xls')" />

        </div>

    </app-actions>

</app-section>

</template>

<script>

import mixCollection from '@/mixin/collection'
import Vue from 'vue'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'dashboard/clinic',
            filter: {
                patient: null
            },
            is: {
                reviewing: false,
                resetting: false
            },
            model: {
                name: ''
            },
            patient: false,
            patients: false,
            record: false
        }
    
    },

    created: function() {
    
        if (this.$route.query.patient) {
        
            this.filter.patient = [this.$route.query.patient]

            this.$router.replace({
                query: null
            })

        }

    },

    computed: {

        title: function() {

            if(this.patient) {

                return this.patient.name
            
            } else if(this.patients) {
            
                return this.$_.pluck(this.patients, 'name').join(', ')
            
            } else {
            
                return 'Overview'
            
            }
        
        },
    
        genericBand: function() {
        
            if (this.record.score.generic >= 26) return 'red'
            else if (this.record.score.generic >= 13) return 'yellow'
            else return 'green'
        
        },
    
        selfBand: function() {
        
            if (this.record.score.self >= 11) return 'red'
            else if (this.record.score.self >= 5) return 'yellow'
            else return 'green'
        
        }
    
    },

    methods: {

        onReviewClick: function(domain) {

            if(!domain.reviewed) {

                this.model.name = ''

                this.is.reviewing = domain

                this.$nextTick(function() {

                    this.$refs.input.focus()

                }.bind(this))

            } else {

                this.is.reviewing = domain

            }
        
        },

        onConfirmReview: function() {

            this.$api.post(this.api, {
                patient: this.patient.id,
                record: this.record.id,
                domain: this.is.reviewing.id,
                name: this.model.name
            }).then(function(response) {
                
                this.is.reviewing.reviewed = !this.is.reviewing.reviewed
                this.is.reviewing.datereviewed = response.date
                this.is.reviewing.namereviewed = response.name

                this.is.reviewing = false
                    
            }.bind(this))


        },

        onCancelReview: function() {

            this.is.reviewing = false

        },

        onExportClick: function(type) {
        
            this.$api.get(this.api, {
                patient: this.filter.patient,
                export: type
            }).then(function(json) {
            
                window.location.href = json.url
                
            })

        },

        onCloseClick: function() {
        
            Vue.set(this, 'patient', false)
            Vue.set(this, 'patients', false)
            Vue.set(this, 'record', false)

            this.filter.patient = null
        
        },
    
        afterLoad: function(json) {
        
            Vue.set(this, 'patient', json.patient)
            Vue.set(this, 'patients', json.patients)
            Vue.set(this, 'record', json.record)
        
        }
    
    }

}

</script>

<style scoped>

.filter-search >>> .input-value {
    width: 320px;
}

.actions {
    justify-content: space-between!important;
}

.actions-counts {
    display: flex;
}

.actions-buttons {
    display: flex;
}

.actions-counts-item {
    height: 52px;
    border-radius: 50px;
    display: flex;
    margin-right: 40px;
}

.actions-counts-item-value {
    height: 52px;
    width: 52px;
    border-radius: 50%;
    line-height: 52px;
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}

.actions-counts-item[data-band="green"] {
    background-color: #95f1b6;
}

.actions-counts-item[data-band="yellow"] {
    background-color: #feedc5;
}

.actions-counts-item[data-band="red"] {
    background-color: #F6C9C6;
}

.actions-counts-item[data-band="green"] .actions-counts-item-value {
    background-color: #11be4e;
}

.actions-counts-item[data-band="yellow"] .actions-counts-item-value {
    background-color: #FFB81C;
}

.actions-counts-item[data-band="red"] .actions-counts-item-value {
    background-color: #DA291C;
}

.actions-counts-item-text { 
    color: #231F20;
    font-size: 16px;
    font-weight: 400;
    line-height: 52px;
    padding: 0px 40px 0px 20px;
}

.review-content {
    position: fixed;
    z-index: 100;
    width: 420px;
    top: 50%;
    left: 50%;
    padding: 10px;
    transform: translate(-50%, -50%);
    right: 0px;
    margin-top: -21px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: grid;
    grid-template-columns: 1fr 40px 40px;
    grid-gap: 10px;
    z-index: 1;
}

.review {
    content: '';
    display: block;
    position: fixed;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(0, 0, 0, 0.25);
    z-index: 2;
}

.review-content input {
    height: 38px;
    z-index: 1;
}

.review-content >>> p {
    font-size: 16px;
    line-height: 20px;
}

</style>
